import { createAction, props } from '@ngrx/store';

import { User } from '@hm/core/models/hm-state.interface';

export const setUser = createAction('[Authorized Content] Set authorized user', props<{ user: User | null }>());
export const logoutUser = createAction('[Authorized Content] Logout authorized user');
